import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    media: {
        height: 140,
        objectFit: 'contain',
    },
}));
